import { uniqueId } from 'lodash';
import React from 'react';
import Select from 'components/Select.jsx';
import Formsy from 'lib/Formsy';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';

const FormSelect = React.createClass({
  propTypes: {
    /* label text */
    label: React.PropTypes.node,
    /* hide label */
    labelHidden: React.PropTypes.bool,
    /* show error even when no change as been made to the input, default is FALSE */
    showErrorOnPristine: React.PropTypes.bool,
  },

  mixins: [Formsy.Mixin],

  getInitialState() {
    return {
      value: this.props.value,
    };
  },

  componentWillMount() {
    this.id = uniqueId('id-');
  },

  onChange(value) {
    this.setValue(value);
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  render() {
    let errorMessage = this.getErrorMessage();

    if (!this.props.showErrorOnPristine && this.isPristine()) {
      errorMessage = null;
    }

    return (
      <Field error={errorMessage}>
        {this.renderLabel()}
        <Select
          {...this.props}
          id={this.id}
          value={this.state.value}
          onChange={this.onChange}
        />
      </Field>
    );
  },
});

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/FormSelect.jsx